// extracted by mini-css-extract-plugin
export default {"page_not_found":"PageNotFound_page_not_found__TOQbI","status_code":"PageNotFound_status_code__f88KD"};